import request from '../../../../util/APIUtils';
import { APDS_GATEWAY_BASE_URL } from '../../../../constants';

const buildUnissuedQuery = ({ limit, offset } = {}) => {
  const params = new URLSearchParams();

  if (limit != null) {
    params.append('limit', String(limit));
  }
  if (offset != null) {
    params.append('offset', String(offset));
  }

  const query = params.toString();
  return query ? `?${query}` : '';
};

export const listUnissuedCertificates = ({ limit, offset } = {}) =>
  request({
    url: `${APDS_GATEWAY_BASE_URL}admin/programs/certificates/unissued${buildUnissuedQuery({
      limit,
      offset,
    })}`,
    method: 'GET',
  });

export const generateProgramCertificate = (programId, personId) =>
  request({
    url: `${APDS_GATEWAY_BASE_URL}admin/programs/${encodeURIComponent(programId)}/certificates/${encodeURIComponent(personId)}/generate`,
    method: 'POST',
  });

export const bulkGenerateProgramCertificates = (pairs) =>
  request({
    url: `${APDS_GATEWAY_BASE_URL}admin/programs/certificates/generate/bulk`,
    method: 'POST',
    body: JSON.stringify({ pairs }),
  });
